import { Checkbox, FormControlLabel } from '@mui/material';

interface LayerCheckboxProps {
  layer: string;
  selectedLayers: string[];
  toggleBuilderViewLayer: (val: string) => void;
}

export const LayerCheckbox = ({
  layer,
  selectedLayers,
  toggleBuilderViewLayer,
}: LayerCheckboxProps) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={selectedLayers.includes(layer)}
          onChange={() => {
            toggleBuilderViewLayer(layer);
          }}
        />
      }
      label={layer}
    />
  );
};
